import React, { useState, useEffect } from 'react';
import './FormStyles.css';
import StepDrawer from './StepDrawer';

function StateSelection({ setCustomState, states, editing, currentStep, totalSteps, onCancel, onContinue, formData, setFormData }) {
  const [error, setError] = useState(null);

  const handleStateChange = (e) => {
    const selectedId = parseInt(e.target.value, 10);
    const selectedState = states.find(state => state.id === selectedId);
    setCustomState("");
    setFormData(prev => ({ ...prev, state: selectedState }));
    onContinue();
  };

  const handleClearSelection = () => {
    setFormData({ ...formData, state: null })
  };


  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <StepDrawer
      currentStep={currentStep}
      totalSteps={totalSteps}
      onCancel={onCancel}
      onContinue={onContinue}
      disabled={!formData?.state}
      title={editing ? "Edit your surgery" : "Share your surgery experience"}
    >
      <div className="form-content">
        <p className="selection-hint">What state did your surgery take place in?</p>
        {formData?.state && (
          <div className="selected-surgeon-container">
            <span className="selected-label">Selected:</span>
            <div className="selected-surgeon-pill">
              <span>{formData.state.name}</span>
              <button className="clear-selection" onClick={handleClearSelection}>×</button>
            </div>
          </div>
        )}
        <select
          value={formData?.state || ''}
          onChange={handleStateChange}
          className="search-input"
          style={{ color: '#666', maxWidth: '400px' }}
        >
          <option value="">Choose a state...</option>
          {states.map(state => (
            <option key={state.id} value={state.id}>
              {state.name}
            </option>
          ))}
        </select>
      </div>
    </StepDrawer>
  );
}

export default StateSelection; 